
import { ToastType } from '@/components/Toast'

interface ToastState {
  message: string
  type: ToastType
  id: string
}

class ToastManager {
  private toasts: ToastState[] = []
  private listeners: Array<(toasts: ToastState[]) => void> = []

  subscribe(listener: (toasts: ToastState[]) => void) {
    this.listeners.push(listener)
    return () => {
      this.listeners = this.listeners.filter(l => l !== listener)
    }
  }

  private notify() {
    this.listeners.forEach(listener => listener([...this.toasts]))
  }

  show(message: string, type: ToastType = 'info') {
    const id = Math.random().toString(36).substr(2, 9)
    const toast: ToastState = { message, type, id }
    
    this.toasts.push(toast)
    this.notify()
    
    // Auto remove after 4 seconds
    setTimeout(() => {
      this.hide(id)
    }, 4000)
  }

  hide(id: string) {
    this.toasts = this.toasts.filter(toast => toast.id !== id)
    this.notify()
  }

  success(message: string) {
    this.show(message, 'success')
  }

  error(message: string) {
    this.show(message, 'error')
  }

  warning(message: string) {
    this.show(message, 'warning')
  }

  info(message: string) {
    this.show(message, 'info')
  }
}

// Singleton global
export const toastManager = new ToastManager()